import * as RA from "fp-ts/ReadonlyArray";
import { useMemo } from "@discovery/common-dplus/lib/hooks";
import * as styles from "./styles.css";
import { cn } from "@discovery/classnames";
export const GenericPageIndicator = ({ itemCount, currentIndex, classNames, }) => {
    const pages = useMemo(() => RA.range(0, itemCount - 1), [itemCount]);
    // TODO: Fix cn()'s return type
    return (React.createElement("div", { className: cn(styles.container, classNames.indicator) }, pages.map((i) => {
        var _a;
        const isSelected = i === currentIndex;
        return (React.createElement("div", { key: i, className: cn(styles.indicatorPill, classNames.indicatorPill, {
                [styles.selectedPill]: isSelected,
                [(_a = classNames.selectedPill) !== null && _a !== void 0 ? _a : ""]: isSelected,
            }) }));
    })));
};

